import React from 'react'
import { compose } from 'redux'
// import { DndProvider } from 'react-dnd';
// import {HTML5Backend} from 'react-dnd-html5-backend';
import hasSaveWPData from '../../hoc/hasSaveWPData'
import toJS from '../../hoc/toJS'
import PageWebsiteSubpagesPage from '../../components/PageWebsiteSubpages/PageWebsiteSubpagesPage'
import { connect } from 'react-redux'
import { AUTH } from '../../constants/state'

const mapStateToProps = state => ({
    caps: state.getIn([AUTH, 'caps'])
})


const PageWebsiteSubpages = ({saveState, status, caps, goBackPath}) => (
    // <DndProvider backend={HTML5Backend}>
        <PageWebsiteSubpagesPage
            saveState={saveState}
            status={status}
            caps={caps}
            closePagePath={goBackPath}
        />
    // </DndProvider>
)

export default compose(
    hasSaveWPData(),
    connect(mapStateToProps),
    toJS()
)(PageWebsiteSubpages)